module.exports = __webpack_public_path__ + "img/screenshot.d69695ab.png";